export class SynchroniserStatutsPiecesResultat {
    constructor() {
        this.dateFinTraitement = null;
        this.piecesSynchronisees = [];
        this.piecesStatutIntrouvable = {};
        this.piecesMotifStatutIntrouvable = {};
        this.erreurs = [];
    }

    public dateFinTraitement: Date | null; 
    public piecesSynchronisees: string[];
    public piecesStatutIntrouvable: Record<string, string>;
    public piecesMotifStatutIntrouvable: Record<string, Array<{ codeStatut: string; codeMotif: string }>>;
    public erreurs: string[];
}